import React, { useEffect, useRef, useState } from "react";
import "./OpenHouseCarousel.css";
import { addToCalendar, formatOpenHouseDate } from "../../constants/methods";
import { useSelector } from "react-redux";
import { LeftArrowIconCircle, RightArrowIconCircle } from "../../constants/icons";
import Slider from "react-slick";

const OpenHouseCarousel = ({
    OpenHouseData,
    closeWrapper,
    container
  }) => {
    const ulRef = useRef(null);
    const dateOptionsRef = useRef(null);
    const [pageNumber, setPageNumber] = useState(0);
    const listingData = useSelector((state) => state.listingData);
    
    const [openhouses, setOpenHouses] = useState([]);
    const [item, setItem] = useState(null);
    useEffect(() => {
        if (OpenHouseData) {
            setOpenHouses(OpenHouseData)
        }
    },[item, OpenHouseData])

    useEffect(() => {
      if (listingData?.data?.OpenHouse?.length){
          setOpenHouses([...listingData?.data?.OpenHouse]);
          setItem(listingData?.data)
          if (container.style.display) {
              container.style.display="unset";
          }
      }
    }, [listingData])

    const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
        <button
          {...props}
          className={
            "slick-arrow date-scheduler-nextArrow" +
            (currentSlide === slideCount - 1 ? " slick-disabled" : "")
          }
          //   aria-hidden="true"
          aria-disabled={currentSlide === 0 ? true : false}
          type="button"
          aria-label="Previous image button"
        >
          <RightArrowIconCircle />
        </button>
      );
      const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
        <button
          {...props}
          className={
            "slick-arrow date-scheduler-prevArrow" +
            (currentSlide === slideCount - 1 ? " slick-disabled" : "")
          }
          //   aria-hidden="true"
          aria-disabled={currentSlide === slideCount - 1 ? true : false}
          type="button"
          aria-label="Next image button"
        >
          <LeftArrowIconCircle />
        </button>
      );

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        swipeToSlide: true,
        // lazyLoad: "ondemand",
        lazyLoad: true,
        nextArrow: <SlickArrowLeft />,
        prevArrow: <SlickArrowRight />,
        // afterChange: (slide) => {
        //   setCurrentSlide(slide + 1);
        // },
      };

    return (
        <div className="open-house-carousel-wrapper">
            <div className="row listerning-page-left-part-search-block-title">
                <h3 className="title">Open House</h3>
            </div>
            <Slider {...settings} initialSlide={pageNumber} ref={dateOptionsRef}>
                {
                    openhouses.map(openhouse=>{
                        return (<div key={openhouse.OpenHouseKeyNumeric} style={{padding: "5px"}}>
                                    <div className="openhouse-item">
                                        <span>{!openhouse.hasOwnProperty("f_date")?formatOpenHouseDate(openhouse,"date"):openhouse.f_date}</span>
                                        <span>{!openhouse.hasOwnProperty("f_date")?formatOpenHouseDate(openhouse,"time"):openhouse.f_date}</span>
                                        <a type="button" role="button" onClick={()=>{addToCalendar(item, openhouse)}}>Add to calendar</a>
                                    </div>
                                </div>
                                )
                    })
                }
            </Slider>
        </div>
    )
}

export default OpenHouseCarousel
